import * as Joi from "joi";

const stringWithNumbersOnlyRegEx = /^\d+$/; // @ref https://github.com/sideway/joi/issues/1157#issuecomment-293538673

export const PersonalInfoSchema = Joi.object({
  email: Joi.any(),
  phoneNumber: Joi.any(),
  username: Joi.any(),
  password: Joi.any(),
  confirmPassword: Joi.any(),
  firstName: Joi.string().trim().min(1).max(100).required().messages({
    "any.required": "First name is required.",
    "string.base": "First name is required.",
    "string.empty": "First name is required.",
    "string.min": "First name can be at most 100 characters only.",
    "string.max": "First name can be at most 100 characters only.",
  }),
  middleName: Joi.string().trim().min(0).max(100).optional().messages({
    "string.base": "Middle name is invalid.",
    "string.empty": "Middle name is invalid.",
    "string.max": "Middle name can be at most 100 characters only.",
  }),
  lastName: Joi.string().trim().min(1).max(100).required().messages({
    "any.required": "Last name is required.",
    "string.base": "Last name is required.",
    "string.empty": "Last name is required.",
    "string.min": "Last name can be at most 100 characters only..",
    "string.max": "Last name can be at most 100 characters only..",
  }),
  pin: Joi.string()
    .trim()
    .length(4)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      "any.required": "Pin is required.",
      "string.base": "Pin is invalid.",
      "string.empty": "Pin is invalid.",
      "string.pattern.base": "Pin is invalid.",
      "string.length": "Pin must have 4 characters only.",
    }),
});
